export const environment = {
  production: false,
  // API_URL_V1: 'http://localhost:9000',
  API_URL_V1: 'https://iqcentral.azurewebsites.net',
  FRONTEND_ENTERPRISE_URL: 'https://dev-org.iqcentral.quomodosystems.ng',
  FRONTEND_LEARNERS_URL: 'https://dev-learner.iqcentral.quomodosystems.ng',
  FRONTEND_CONTENT_PROVIDERS_URL: 'https://dev-cp.iqcentral.quomodosystems.ng',
  FRONTEND_HOMEPAGE_URL: 'https://dev-iqcentral.quomodosystems.ng',
};
